<template>
	<div v-loading.fullscreen.lock="fullscreenLoading">
		<TopHeader :tabIndex='1'></TopHeader>

		<div class="cont">
			<div class="flex flex-b">
				<div class="title">课程中心</div>
				<div class="search flex">
					<img src="../../assets/icon/search.png" style="width: 16px;height: 16px;" alt="" />
					<input type="text" v-model="keyword" placeholder="搜索课程" @keyup.enter="search()">
				</div>
			</div>
			<div class="flex-only" style="margin-top: 30px;">
				<div class="tit">一级分类</div>
				<div class="flex flex-1 flex-wrap">
					<div class="item pointer" :class="tabIndex1==0?'active':''" @click="getFirstName(0)">全部</div>
					<div class="item pointer" v-for="(item,index) in firstList" :class="tabIndex1==index+1?'active':''"
						@click="getFirstName(item,index)">{{item.name}}</div>
				</div>
			</div>
			<div class="flex-only" style="margin-top: 10px;">
				<div class="tit">二级分类</div>
				<div class="flex flex-1 flex-wrap">
					<div class="item pointer" :class="tabIndex2==0?'active':''" @click="getSecondName(0)">全部</div>
					<div class="item pointer" v-if="tabIndex1!== 0" v-for="(item,index) in secondList"
						:class="tabIndex2==index+1?'active':''" @click="getSecondName(item,index)">{{item.name}}</div>
				</div>
			</div>
			<div class="result">共找到 <span>{{courseCount}}</span> 门课程</div>

			<div class="navs flex">
				<div class="navItem pointer" :class="navIndex==0?'active2':''" @click="change(0)">全部</div>
				<div class="navItem pointer" :class="navIndex==1?'active2':''" @click="change(1)">热点</div>
				<div class="navItem pointer" :class="navIndex==2?'active2':''" @click="change(2)">精品</div>
			</div>

			<div class="flex flex-wrap">
				<div class="itembg1 pointer" v-for="item in courseList" @click="toCourseDetail(item)">
					<img :src="item.img" style="width: 100%;border-radius: 13px;" />
					<div class="ititle">{{item.name}}</div>
					<div class="flex flex-b">
						<div class="flag flex flex-c">{{item.course_cate_name}}</div>
						<div class="flag1">{{item.sub_course_cate_name}}</div>
					</div>
					<div class="flex flex-b" style="margin-top: 24px;">
						<div class="price flex">{{item.score}}
							<div class="span">积分</div>
						</div>
					</div>
				</div>
			</div>
			<pagination :page_size='page_size' :total="courseCount" @currentChange='currentChange'></pagination>
		</div>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getCourse,
		getCourseCate
	} from "@/api/course";
	import TopHeader from "../../components/TopHeader.vue";
	import Footer from "../../components/Footer.vue";
	import Pagination from '../../components/Pagination.vue';
	import toTop from '../../components/toTop.vue'
	export default {
		components: {
			TopHeader,
			Footer,
			Pagination,
			toTop
		},
		data() {
			return {
				tabIndex1: 0,
				tabIndex2: 0,
				navIndex: 0,
				firstList: [], //一级分类
				secondList: [], //二级分类
				firstKey: '', //一级分类uuid
				secondKey: '', //二级分类uuid
				courseList: [],
				is_quality: '',
				is_hot: '',
				keyword: '',
				courseCount:0,
				page_index:1,
				page_size:12,
				fullscreenLoading:true
			}
		},
		mounted() {
			if(this.$route.query.is_hot){
				this.change(1)
			}
			this.getCourseCate()
			this.getCourse()
		},
		methods: {
			search() {
				this.getCourse()
			},
			toCourseDetail(item) {
				this.$router.push({
					path: '/courseDetail',
					query: {
						id: item.uuid,
						course_cate_name: item.course_cate_name
					}
				})
			},
			//全部热点精品
			change(e) {
				this.navIndex = e
				if (e == 1) {
					this.is_hot = 1
					this.is_quality = ''
				} else if (e == 2) {
					this.is_hot = ''
					this.is_quality = 1
				} else {
					this.is_hot = ''
					this.is_quality = ''
				}
				this.getCourse()
			},
			getFirstName(item, index) {
				if (item == 0) {
					this.firstKey = ''
					this.tabIndex1 = 0
					this.tabIndex2 = 0
					this.secondList = []
					this.is_hot = ''
					this.is_quality = ''
					this.firstKey = ''
					this.secondKey = ''
					this.getCourse()
					return
				}
				this.tabIndex1 = index + 1
				this.firstKey = item.uuid
				this.secondList = []
				this.tabIndex2 = 0
				this.getCourse()
				this.getCourseCate2()
			},
			getSecondName(item, index) {
				if (item == 0) {
					this.is_hot = 2
					this.is_quality = 2
					this.tabIndex2 = 0
					this.secondKey = ''
					this.getCourse()
					return
				}
				this.tabIndex2 = index + 1
				this.secondKey = item.uuid
				this.getCourse()
			},
			//课程列表
			async getCourse() {
				const {
					status,
					data
				} = await getCourse({
					course_cate_uuid: this.firstKey,
					sub_course_cate_uuid: this.secondKey,
					is_quality: this.is_quality,
					is_hot: this.is_hot,
					keyword: this.keyword,
					page_index:this.page_index,
					page_size:this.page_size
				})
				this.courseList = data.result.data
				this.courseCount = data.result.total
				this.fullscreenLoading = false
			},
			//一级课程分类
			async getCourseCate() {
				const {
					status,
					data
				} = await getCourseCate({})
				this.firstList = data.result
			},
			//二级课程分类
			async getCourseCate2() {
				const {
					status,
					data
				} = await getCourseCate({
					pid: this.firstKey
				})
				this.secondList = data.result
			},
			//改变页数
			currentChange(e) {
				this.page_index = e
				this.getCourse()
			},
		}
	}
</script>

<style lang="less" scoped>
	.toTop {
		position: fixed;
		right: 190px;
		bottom: 143px;
		background: url('../../assets/images/home/top.png') no-repeat;
		width: 53px;
		height: 53px;
		z-index: 9999;
		background-size: 100% 100%;
		cursor: pointer;
	}

	.cont {
		padding: 60px 133px 0;

		.title {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 27px;
			color: #000000;
		}

		.search {
			height: 40px;
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			input {
				margin-left: 10px;
				border: none;
				background-color: transparent;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333;

				&:focus {
					outline: none;
				}
			}
		}

		.tit {
			width: 7%;
			line-height: 36px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
		}

		.item {
			margin: 0 20px 14px 0;
			height: 36px;
			padding: 0 14px;
			background: #FFFFFF;
			border-radius: 9px 9px 9px 9px;
			border: 1px solid #EEEEEE;
			opacity: 0.8;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 16px;
			color: #333333;
			line-height: 36px;
		}

		.active {
			height: 36px;
			border: 1px solid rgba(0, 167, 60, 0.06);
			background: rgba(0, 167, 60, 0.06);
			border-radius: 9px 9px 9px 9px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 16px;
			color: #00A73C;
			line-height: 36px;
		}

		.result {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			color: #000000;
			line-height: 60px;

			span {
				color: #00A73C;
			}
		}

		.navs {
			margin-bottom: 20px;
		}

		.navItem {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #999999;
			margin-right: 20px;
		}

		.active2 {
			color: #00A73C;
		}

		.itembg1 {
			width: calc(25% - 27px);
			margin-right: 27px;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			background: #FFFFFF;
			border-radius: 13px 13px 13px 13px;
			padding: 9px 11px;
			position: relative;
			margin-bottom: 20px;

			&:nth-child(4n) {
				margin-right: 0;
			}

			.ititle {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
				margin-top: 13px;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
			}

			.addItem {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
			}

			.flag {
				margin-top: 16px;
				height: 22px;
				padding: 0 10px;
				background: rgba(0, 167, 60, 0.06);
				border-radius: 4px 4px 4px 4px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
			}

			.flag1 {
				margin-top: 16px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}

			.price {
				font-family: DINPro, DINPro;
				font-weight: bold;
				font-size: 22px;
				color: #00A73C;

				.span {
					margin-left: 2px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #00A73C;
					margin-top: 5px;
				}
			}

			.ygm {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}
		}
	}
</style>